<template>
    <div>
        <b-button
                disabled
                v-show="showFolderIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="folder-open"></icon>
        </b-button>        

        <b-button
                disabled
                v-show="showImageIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="file-image-o"></icon>
        </b-button>

        <b-button
                disabled
                v-show="showWordIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="file-word-o"></icon>
        </b-button>

        <b-button
                disabled
                v-show="showExcelIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="file-excel-o"></icon>
        </b-button>

        <b-button
                disabled
                v-show="showPowerPointIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="file-powerpoint-o"></icon>
        </b-button>

        <b-button
                disabled
                v-show="showPdfIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="file-pdf-o"></icon>
        </b-button>

        <b-button
                disabled
                v-show="showTextFileIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="file-text-o"></icon>
        </b-button>

        <b-button
                disabled
                v-show="showZipIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="file-zip-o"></icon>
        </b-button>

        <b-button
                disabled
                v-show="showCodeIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="file-code-o"></icon>
        </b-button>

        <b-button
                disabled
                v-show="showDefaultIcon()"
                variant="outline-secondary"
                class="pb-0 pt-1 border-0 text-secondary"
                style="pointer: none;">
            <icon name="file-o"></icon>
        </b-button>

        &nbsp;{{ params.value }}
    </div>
</template>

<script>
import Vue from 'vue';
import utils from '../../../Utils.js';

export default Vue.extend({
    methods: {
        showFolderIcon() {
            return this.params.data.type.toUpperCase() !== 'DOCUMENT';
        },

        showImageIcon() {
            let ext = utils.getFileTypeExtension(this.params.data);
            let imgExtensions = ['PNG', 'JPEG', 'JPG', 'GIF', 'SVG', 'ICO', 'TIFF'];

            if (imgExtensions.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },

        showWordIcon() {
            let ext = utils.getFileTypeExtension(this.params.data);
            let imgExtensions = ['WORD', 'DOC', 'DOCX'];

            if (imgExtensions.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },

        showExcelIcon() {
            let ext = utils.getFileTypeExtension(this.params.data);
            let imgExtensions = ['EXCEL', 'XLS', 'XLSX'];

            if (imgExtensions.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },

        showPowerPointIcon() {
            let ext = utils.getFileTypeExtension(this.params.data);
            let imgExtensions = ['POWERPOINT', 'PPT', 'PPTX'];

            if (imgExtensions.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },

        showPdfIcon() {
            let ext = utils.getFileTypeExtension(this.params.data);
            let imgExtensions = ['PDF'];

            if (imgExtensions.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },

        showTextFileIcon() {
            let ext = utils.getFileTypeExtension(this.params.data);
            let imgExtensions = ['TXT'];

            if (imgExtensions.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },

        showZipIcon() {
            let ext = utils.getFileTypeExtension(this.params.data);
            let imgExtensions = ['ZIP'];

            if (imgExtensions.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },

        showCodeIcon() {
            let ext = utils.getFileTypeExtension(this.params.data);
            let imgExtensions = ['HTML', 'XHTML', 'XML', 'CSS', 'JS', 'JSON'];

            if (imgExtensions.includes(ext)) {
                return true;
            } else {
                return false;
            }
        },

        showDefaultIcon() {
            let ext = utils.getFileTypeExtension(this.params.data);
            let extensions = ['PNG', 'JPEG', 'JPG', 'GIF', 'SVG', 'ICO', 'TIFF', 'WORD', 'DOC', 'DOCX', 'EXCEL', 'XLS', 'XLSX', 'POWERPOINT', 'PPT', 'PPTX', 'PDF', 'TXT', 'ZIP', 'HTML', 'XHTML', 'XML', 'CSS', 'JS', 'JSON'];

            if (this.params.data.type.toUpperCase() === 'DOCUMENT' && !extensions.includes(ext)) {
                return true;
            } else {
                return false;
            }
        }
    }
});
</script>
